var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriberPlanTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 75,
    viewBox: "0 0 120 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    rx: 6.27451,
    fill: "url(#paint0_linear_12927_137052)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_12927_137052)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    rx: 6.27451,
    fill: "white",
    fillOpacity: 0.03
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 44.9508V66.9989C120 71.4171 116.418 74.9989 112 74.9989H18.6455C23.8995 44.727 47.4742 21.8906 75.7616 21.8906C93.4659 21.8906 109.324 30.8359 120 44.9508Z",
    fill: "white",
    fillOpacity: 0.06
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_12927_137052",
    x: -25.098,
    y: -25.098,
    width: 170.196,
    height: 125.196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12927_137052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_12927_137052",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12927_137052",
    x1: -17.194,
    y1: -8.10811,
    x2: 144.483,
    y2: 66.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122247,
    stopColor: "#042843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878935,
    stopColor: "#726E9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriberPlanTeam);
export default __webpack_public_path__ + "static/media/subscriber-plan-team.8f3ae1b5ba824c1179d775ce0597e3d0.svg";
export { ForwardRef as ReactComponent };